module.exports = __webpack_public_path__ + "assets/e976b599d93bb23fc708296c02723913.png";